export const energyDetailsPageConstants={
    ENERGY_DETAILS_PAGE_SUCCESS:"ENERGY_DETAILS_PAGE_SUCCESS",
    ENERGY_DETAILS_PAGE_ERROR:"ENERGY_DETAILS_PAGE_ERROR",
    UPDATE_ENERGY_DETAILS_PAGE:"UPDATE_ENERGY_DETAILS_PAGE",
  }